import { Abwesenheiten } from '@/domain/mitarbeiter/features/guttagekonto/shared/entities/Abwesenheiten';

export function calculateSumFaktor({
  abwesenheiten,
}: {
  abwesenheiten: Abwesenheiten[];
}) {
  let sum = 0;
  for (const item of abwesenheiten) {
    sum = sum + item.faktor;
  }
  return sum;
}

export function calculateSumDauer({
  abwesenheiten,
}: {
  abwesenheiten: Abwesenheiten[];
}) {
  let sum = 0;
  for (const item of abwesenheiten) {
    sum = sum + item.dauer;
  }
  return sum;
}
